import Vue from 'vue'
import Router from 'vue-router'
// import Products from '@/components/Products'
import Home from '@/components/Home/Home'
import Feature from '@/components/Feature/Feature'
import Prices from '@/components/Prices/'
import Resource from '@/components/Resources/Resources'
import Contact from '@/components/Contact/Contact'
import About from '@/components/About'
import Download from '@/components/Download'
import Serversupport from '@/components/Serversupport'

Vue.use(Router)

export default new Router({
  routes: [{
    path: '/',
    redirect: '/Home',
    name: 'Home',
    component: Home
  }, {
    path: '/Home',
    name: 'Home2',
    component: Home
  }, {
    path: '/Feature',
    name: 'Feature',
    component: Feature
  }, {
    path: '/Prices',
    name: 'Prices',
    component: Prices
  }, {
    path: '/Resource',
    name: 'Resource',
    component: Resource
  }, {
    path: '/contact',
    name: 'contact',
    component: Contact
  }, {
    path: '/about',
    name: 'about',
    component: About
  }, {
    path: '/download',
    name: 'download',
    component: Download
  }, {
    path: '/serversupport',
    name: 'serversupport',
    component: Serversupport
  }]
})



// WEBPACK FOOTER //
// ./src/router/index.js